// ============================================================================
// The subcontractor's status words and what the screens call them — ONE file.
// Item #683, rulings TCSD-0368 (one record for life), TCSD-0207 (three pipeline
// stages, unchanged) and TCSD-0373 ¶9 (stored values never change; the app shows
// a label per stage from one shared vocabulary; the AI speaks the labels).
//
// ⛔ The stored words are the CHECK on service_providers.provider_status:
//    Lead · Meet · Ready · Active · Inactive · Pending · Onboarding.
//    Nothing here may add one. A word this file invents is a write Postgres refuses.
// ============================================================================

/** The pipeline, in order. "Ready" IS the bench (TCSD-0368). */
export const PIPELINE_STAGES = ['Lead', 'Meet', 'Ready'] as const;
export type PipelineStage = (typeof PIPELINE_STAGES)[number];

export const SUB_STATUSES = ['Lead', 'Meet', 'Ready', 'Active', 'Inactive', 'Pending', 'Onboarding'] as const;
export type SubStatus = (typeof SUB_STATUSES)[number];

/** What a person reads. The stored word stays the stored word. */
export const SUB_STATUS_LABELS: Record<SubStatus, string> = {
  Lead: 'Lead',
  Meet: 'Interviewing',
  Ready: 'Bench',
  Active: 'Active',
  Inactive: 'Inactive',
  Pending: 'Pending',
  Onboarding: 'Onboarding',
};

export function subStatusLabel(status: string | null | undefined): string {
  if (!status) return '—';
  return (SUB_STATUS_LABELS as Record<string, string>)[status] ?? status;
}

export function isPipelineStage(s: string | null | undefined): s is PipelineStage {
  return (PIPELINE_STAGES as readonly string[]).includes(s ?? '');
}

/** The service catalogue's own groups (service_divisions), as stored in
 *  service_providers.capabilities when an account manager SAYS what a sub does.
 *  "Nightly" is the recurring axis; project work is the three work divisions.
 *  Ben, 2026-10-03 (item #683, Decision 2 = A). */
export const NIGHTLY_DIVISIONS = ['RECURRING'] as const;
export const PROJECT_DIVISIONS = ['CLEAN', 'FLOOR', 'GROUNDS'] as const;
